import React from 'react';
import styled from 'styled-components';
import { Box, CircularProgress } from '@mui/material';
import MuiIconButton from '@mui/material/IconButton';
import type { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';
import { useNavigate } from '../utils/hooks';

import iconNameDict, { IconName } from '../utils/iconNameDict';

const StyledIconButton = styled(MuiIconButton)<{ $backgroundColor?: string; $iconColor?: string }>`
	background-color: ${(p) => p.$backgroundColor || ''};
	color: ${(p) => p.$iconColor || ''};
	margin: 0;
	padding: 0;
`;

const IconButton = ({
	id,
	m,
	p,
	loading,
	color,
	onClick,
	iconName,
	navigateTo,
	iconColor,
	backgroundColor,
	...rest
}: {
	id?: string;
	m?: string;
	p?: string;
	loading?: boolean;
	color?: string;
	onClick?: (val?: any) => any;
	iconName: IconName;
	navigateTo?: string;
	iconColor?: string;
	backgroundColor?: string;
} & Omit<MuiIconButtonProps, 'color'>): JSX.Element => {
	const navigate = useNavigate();
	const handleClick = React.useCallback(() => {
		if (navigateTo) {
			navigate(navigateTo);
		} else {
			onClick?.(id);
		}
	}, [id, navigate, navigateTo, onClick]);

	const Icon = iconName && iconNameDict[iconName] ? iconNameDict[iconName] : null;

	return (
		<Box m={m} p={p} position="relative">
			<StyledIconButton
				{...rest}
				$backgroundColor={backgroundColor}
				$iconColor={iconColor}
				onClick={handleClick}
			>
				{loading ? (
					// eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
					<CircularProgress size={24} sx={{ color }} />
				) : Icon ? (
					<Icon />
				) : null}
			</StyledIconButton>
		</Box>
	);
};

export default React.memo(IconButton);
